import { Inject, Injectable, DOCUMENT , DestroyRef} from '@angular/core';

import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable()
export class FuseSplashScreenService
{
    /**
     * Constructor
     */
    constructor(@Inject(DOCUMENT) private _document: any,
        private _router: Router, private readonly destroyRef: DestroyRef)
    {
        // Hide it on the first NavigationEnd event
        this._router.events
            .pipe(takeUntilDestroyed(this.destroyRef), 
                filter(event => event instanceof NavigationEnd),
                take(1)
            )
            .subscribe(() => {
                this.hide();
            });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Show the splash screen
     */
    show(): void
    {
        this._document.body.classList.remove('fuse-splash-screen-hidden');
    }

    /**
     * Hide the splash screen
     */
    hide(): void
    {
        this._document.body.classList.add('fuse-splash-screen-hidden');
    }
}
